/* eslint-disable security/detect-object-injection */
import axios from "axios";
import * as GlobalService from "../react/global_services";
var isFirstTimeOpen = true;
var keyName = "ParcelShipments";
var metaDataParcelShipmentsObject = {
    "ParcelShipments": {
        "filterData": {},
        "gridConfig": {},
        "saveFilter": [],
    },
};
declare var window: any;
const { $ } = window;

export const setGridFilter = function (param_filterObj, cancleToken) {
    let url = "/WebUI/Shipping/SmartParcel/ShipmentTrackingFilteredRowCount";

    return axios.put(url, param_filterObj, { cancelToken: cancleToken }).then((response: any) => {
        return response;
    });
};

export const getShipEngineCarriers = function () {
    return axios.get("/WebUI/Settings/SmartParcel/ShipEngineCarriers").then((response: any) => {
        return response;
    });
};

// call api for get metaData of ParcelShipments is it's open first time
export const getParcelShipmentsClientMetaData = function () {
    if (isFirstTimeOpen) {
        return GlobalService.getUserClientMetaData(keyName).then(
            function successCallBack(response) {
                if (response !== "") {
                    Object.assign(metaDataParcelShipmentsObject[`${keyName}`], JSON.parse(response));
                }
                isFirstTimeOpen = false;
                return true;
            },
            function errorCallBack(response) {
                return false;
            }
        );
    }
};

export const setParcelShipmentsFilterMetaData = function (filterData) {
    metaDataParcelShipmentsObject[`${keyName}`]["filterData"] = filterData;
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataParcelShipmentsObject[`${keyName}`]));
};

export const getParcelShipmentsFilterMetaData = function () {
    if (!$.isEmptyObject(metaDataParcelShipmentsObject[`${keyName}`]["filterData"])) {
        return metaDataParcelShipmentsObject[`${keyName}`]["filterData"];
    } else {
        return "";
    }
};

export const saveParcelShipmentsFilterMetaData = function (title, filterObj, columnObj) {
    var setData = {
        title: title,
        filterData: filterObj,
        columnData: columnObj.optionsData,
    };
    if (typeof metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"] == "undefined") {
        metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"] = [];
    }
    metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"].push(setData);
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataParcelShipmentsObject[`${keyName}`]));
};
export const updateParcelShipmentsFilterMetaData = function (index, filterObj, columnObj) {
    if (typeof metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"][index] != "undefined") {
        metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"][index].filterData = filterObj;
        metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"][index].columnData = columnObj.optionsData;
        GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataParcelShipmentsObject[`${keyName}`]));
    }
};
export const getSaveParcelShipmentsFilterListMetaData = function () {
    return metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"];
};
export const clearSaveParcelShipmentsFilterListMetaData = function (index) {
    metaDataParcelShipmentsObject[`${keyName}`]["saveFilter"].splice(index, 1);
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataParcelShipmentsObject[keyName]));
};
export const setParcelShipmentsGridOptionInMetaData = function (gridConfig) {
    metaDataParcelShipmentsObject[`${keyName}`]["gridConfig"] = gridConfig.optionsData;
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataParcelShipmentsObject[`${keyName}`]));
};
export const getParcelShipmentsGridOptionInMetaData = function () {
    if (!$.isEmptyObject(metaDataParcelShipmentsObject[`${keyName}`]["gridConfig"])) {
        return metaDataParcelShipmentsObject[`${keyName}`]["gridConfig"];
    } else {
        return "";
    }
};

export const clearParcelShipmentsFilterMetaData = function () {
    metaDataParcelShipmentsObject[`${keyName}`]["filterData"] = {};
    GlobalService.setUserClientMetaData(keyName, JSON.stringify(metaDataParcelShipmentsObject[`${keyName}`]));
};

export const getTrackPackageInfo = function (packageuri: string) {
    return axios.get(`/WebUI/Shipping/SmartParcel/TrackPackageInfo?packageuri=${packageuri}`).then((response: any) => {
        return response.data;
    });
};
